import * as React from 'react';
import { useState } from 'react';
import { Select } from 'components/select/select';
import { PmxComponent } from 'core/components/PmxComponenet';
import './dropdown.scss';
import { DownOutlined } from '@ant-design/icons';

interface DropdownItem {
    id: number | string;
    title: string;
    icon?: React.ReactElement;
}

interface Props extends PmxComponent {
    disabled?: boolean;
    onChangeHandle?: (value: number | string) => void;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    items: DropdownItem[];
    defaultSelected?: DropdownItem;
    dropDownButtonIcon?: React.ReactNode;
    selectedOption?: DropdownItem;
}

// این کامپوننت قبلاً یک پیاده‌سازی دستی با div/ul بود که چند مشکل داشت:
// پاپ‌آور هم‌عرض تریگر باز نمی‌شد، لیست بلند اسکرول نمی‌خورد و آیتم‌ها بریده می‌شدند،
// و داخل مودال زیر لبه‌ها گم می‌شد. حالا روی antd Select سوار شده تا عرض پاپ‌آور،
// اسکرول، پیمایش با کیبورد و RTL را خودِ antd مدیریت کند.
// پراپ‌ها عمداً بدون تغییر مانده‌اند تا همهٔ محل‌های استفادهٔ فعلی دست‌نخورده کار کنند.
export const Dropdown: React.FC<Props> = (props) => {
    const [internalSelected, setInternalSelected] = useState<DropdownItem | undefined>(
        props.defaultSelected ?? props?.items?.[0],
    );

    // وقتی selectedOption داده شود کامپوننت کنترل‌شده است، وگرنه انتخاب داخلی ملاک است.
    const selected = props.selectedOption ?? internalSelected;

    const options = (props.items ?? []).map((item) => ({
        value: item.id,
        label: (
            <span className="dropdown-option">
                {item.icon}
                <span>{item.title}</span>
            </span>
        ),
    }));

    return (
        <div className={`pmx-dropdown ${props.className && props.className !== '' ? props.className : ''}`}>
            <Select
                className="dropdown-selector"
                value={selected?.id}
                options={options}
                disabled={props.disabled}
                suffixIcon={props.dropDownButtonIcon ?? <DownOutlined />}
                onChange={(value) => {
                    const item = props.items?.find((i) => i.id === value);
                    if (item) setInternalSelected(item);
                    props.onChangeHandle && props.onChangeHandle(value);
                }}
            />
        </div>
    );
};
